<script setup lang="ts">
const { isLoggedIn, logout, user } = useUser();

const loginModalController = useModal();
const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const isAccountMenuOpen = ref(false);
const router = useRouter();

async function invokeLogout() {
  await logout();
  isAccountMenuOpen.value = false;
}

async function invokeResetPassword() {
  await router.push(formatLink("/account/recover"));
  loginModalController.close();
}
</script>
<template>
  <div>
    <ClientOnly>
      <div v-show="!isLoggedIn">
        <a href="#" @click="loginModalController.open" class="account svg-icon">
          <svg
            viewBox="0 0 22 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9998 13.1667C14.2215 13.1667 16.8332 10.555 16.8332 7.33333C16.8332 4.11167 14.2215 1.5 10.9998 1.5C7.77818 1.5 5.1665 4.11167 5.1665 7.33333C5.1665 10.555 7.77818 13.1667 10.9998 13.1667Z"
              stroke="#202020"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M20.3332 22.5C20.3332 20.0246 19.3498 17.6506 17.5995 15.9003C15.8492 14.15 13.4752 13.1666 10.9998 13.1666C8.52448 13.1666 6.15051 14.15 4.40017 15.9003C2.64983 17.6506 1.6665 20.0246 1.6665 22.5"
              stroke="#202020"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      <SharedModal :controller="loginModalController">
        <AccountLoginForm
          @close="loginModalController.close"
          @success="loginModalController.close"
        >
          <div class="flex items-center justify-end">
            <div class="text-sm">
              <NuxtLink
                class="font-medium text-black hover:text-red cursor-pointer"
                @click.stop="invokeResetPassword"
              >
                {{ $t("recoveryPassword.forgotPassword") }}
              </NuxtLink>
            </div>
          </div>
        </AccountLoginForm>
      </SharedModal>
      <div v-if="isLoggedIn">
        <div
          class="inset-y-2 flex items-center sm:static sm:inset-auto sm:ml-1 sm:pr-0"
        >
          <a
            href="#"
            @click="isAccountMenuOpen = !isAccountMenuOpen"
            class="account svg-icon w-6 h-6"
          >
            <svg
              viewBox="0 0 22 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.9998 13.1667C14.2215 13.1667 16.8332 10.555 16.8332 7.33333C16.8332 4.11167 14.2215 1.5 10.9998 1.5C7.77818 1.5 5.1665 4.11167 5.1665 7.33333C5.1665 10.555 7.77818 13.1667 10.9998 13.1667Z"
                stroke="#202020"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20.3332 22.5C20.3332 20.0246 19.3498 17.6506 17.5995 15.9003C15.8492 14.15 13.4752 13.1666 10.9998 13.1666C8.52448 13.1666 6.15051 14.15 4.40017 15.9003C2.64983 17.6506 1.6665 20.0246 1.6665 22.5"
                stroke="#202020"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>

          <!-- Profile dropdown -->
          <div class="relative">
            <Transition
              enter-active-class="transition ease-out duration-100"
              enter-from-class="transform opacity-0 scale-95"
              enter-to-class="transform opacity-100 scale-100"
              leave-active-class="transition ease-in duration-75"
              leave-from-class="transform opacity-100 scale-100"
              leave-to-class="transform opacity-0 scale-95"
            >
              <div
                v-if="isAccountMenuOpen"
                :class="[isAccountMenuOpen ? 'block' : 'hidden']"
                class="z-20 origin-top-right absolute right-0 top-2 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                role="menu"
                aria-orientation="vertical"
                aria-labelledby="user-menu-button"
                tabindex="-1"
              >
                <NuxtLink
                  id="user-menu-item-1"
                  :to="formatLink('/account')"
                  data-testid="header-my-account-link"
                  class="block px-4 py-2 text-sm text-secondary-700 hover:bg-secondary w-full text-left"
                  tabindex="-1"
                >
                  {{ $t("account.menu.myAccount") }}
                </NuxtLink>
                <button
                  id="user-menu-item-2"
                  data-testid="header-sing-out-link"
                  class="block px-4 py-2 text-sm text-secondary-700 hover:bg-secondary w-full text-left"
                  role="menuitem"
                  tabindex="-2"
                  @click="invokeLogout"
                >
                  {{ $t("account.menu.signOut") }}
                </button>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </ClientOnly>
    <!-- <a
    href="#"
    class="ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700"
  >
    Sign up
  </a> -->
  </div>
</template>
